<template>
  <div class="product">
    <tips class="product-tip">
      <div class="product-tip__line"> 1. 当产品包装材料或尺寸不同，产品配件不相同，甚至产品颜色不相同等，将引起产品的体积，重量，材料成本甚至物流费用等不相同，因此当产品有差异时需要新建不同的产品信息； </div>
      <div class="product-tip__line"> 2.另外,即使产品相同或非常相近,但当供应商不同时,可以理解为产品不同,需分别单独新建产品信息; </div>
    </tips>
    <div class="product-top">
      <div class="product-top__title">产品管理</div>
      <div class="product-top__search">
        <div class="product-top__item">
          <div class="product-top__name">产品状况:</div>
          <el-select
            size="mini"
            popper-class="productStatusSelect"
            ref="productStatusSelect"
            placeholder="请选择产品状态"
            v-model="searchData.status"
            multiple collapse-tags>
            <div class="product-top-status">
              <div class="product-top-module">
                <div class="product-top-module__title">
                  必选项1
                  <span class="product-top-module__tip">(单选)</span>
                </div>
                <el-option
                  v-for="item in productStatusArray.slice(0, 3)"
                  :key="item"
                  :label="item"
                  :value="item">
                  <el-checkbox
                    :label="item"
                    :value="judgeStatusCheckBox(item)"
                    @change="statusCheckChange($event, item)"></el-checkbox>
                </el-option>
              </div>
              <div class="product-top-module">
                <div class="product-top-module__title">
                  必选项2
                  <span class="product-top-module__tip">(单选)</span>
                </div>
                <el-option
                  v-for="item in productStatusArray.slice(3, 6)"
                  :key="item"
                  :label="item"
                  :value="item">
                  <el-checkbox
                    :label="item"
                    :value="judgeStatusCheckBox(item)"
                    @change="statusCheckChange($event, item)"></el-checkbox>
                </el-option>
              </div>
              <div class="product-top-module">
                <div class="product-top-module__title">
                  非必选项
                  <span class="product-top-module__tip">(可多选,请如实勾选)</span>
                </div>
                <el-option
                  v-for="item in productStatusArray.slice(6, 9)"
                  :key="item"
                  :label="item"
                  :value="item">
                  <el-checkbox
                    :label="item"
                    :value="judgeStatusCheckBox(item)"
                    @change="statusCheckChange($event, item)"></el-checkbox>
                </el-option>
              </div>
            </div>
          </el-select>
        </div>
        <div class="product-top__item">
          <div class="product-top__name">产品分类:</div>
          <el-select size="mini" v-model="searchData.sort">
            <el-option
              v-for="(item, index) in productSortArray"
              :key="item"
              :label="item"
              :value="index"></el-option>
          </el-select>
        </div>
        <div class="product-top__item">
          <el-input size="mini"
            v-model="searchData.text"
            class="product-top__input"
            placeholder="请输入产品ID/型号/名称/海关编码等"></el-input>
        </div>
        <div class="product-top__btn" @click="searchBtnClick">查询</div>
        <div class="product-top__btn" @click="newProductBtnClick">新建产品信息</div>
      </div>
    </div>
    <div class="product-table">
      <Table
        :head="productTableHead"
        :body="productList"
        @deleteData="deleteTableData"
        @changeData="changeTableData"
        width="1654"
        height="550"></Table>
    </div>
  </div>
</template>

<script>
import { ProductSearchData, ProductNewModule, ProductList } from './class'
import globalData from 'common/globalData';
import tips from '../common/tips.vue';
import Table from 'components/common/Table.vue'
import ProductAxios from 'service/product'
export default {
  name: 'productInfo',
  components: {
    tips, Table
  },
  data(){
    return {
      /**搜索数据 */
      searchData: new ProductSearchData(),
      /**产品状态数组 */
      productStatusArray: globalData.productStatusInputOptions,
      /**产品分类 */
      productSortArray: globalData.sortInputOptions,
      /**产品表头 */
      productTableHead: ProductNewModule.NEWTABLEHEAD(),
      /**产品列表 */
      productList: []
    }
  },
  methods:{
    /**判断当前checkBox是否被选择 */
    judgeStatusCheckBox(label){
      return this.searchData.status.includes(label)
    },
    /**产品状态select checkBox点击事件 */
    statusCheckChange(bool, label){
      if(!bool){
        this.searchData.status.push(label)
      }else{
        this.searchData.status = this.searchData.status.filter(s => s != label)
      }
      let arr = this.searchData.status.map(v => this.productStatusArray.indexOf(v))
      let resultIndexArr = []
      let battery = arr.filter(i => i >=0 && i <= 2).pop()
      let magnetic = arr.filter(i => i >=3 && i <= 5).pop()
      let otherArr = arr.filter(i => i >= 6)
      if(battery !== undefined) resultIndexArr.push(battery)
      if(magnetic !== undefined) resultIndexArr.push(magnetic)
      resultIndexArr = resultIndexArr.concat(otherArr)
      this.searchData.status = resultIndexArr.map(i => this.productStatusArray[i])
    },
    /**获取产品列表 */
    async getProductList(bool = false){
      let res = await ProductAxios.productList(this.searchData.getSearchAxiosBody)
      if(res.data.code !== 1){
        this.$message.error(res.data.info)
        return;
      }
      if(bool) this.$message.success('查询成功')
      let list = res.data.info
      this.productList.splice(0, this.productList.length)
      list.map(l => {
        let productData = new ProductList()
        productData.backendListDataParsing(l)
        this.productList.push(productData)
      })
    },
    /**删除数据 */
    async deleteTableData(index){
      let id = this.productList[index].id
      let res = await ProductAxios.deleteProduct(id)
      if(res.data.code === 1){
        this.$message.success(res.data.info)
        this.productList.splice(index, 1)
      }else{
        this.$message.error(res.data.info)
      }
    },
    /**修改数据 */
    changeTableData(index){
      this.$emit('go', {
        id: 'newProductInfo',
        name: this.productList[index].model,
        index: index,
        obj: {
          type: 'change',
          id: this.productList[index].id
        }
      })
    },
    /**查询按钮点击事件 */
    searchBtnClick(){
      this.getProductList(true)
    },
    /**新建产品点击事件 */
    newProductBtnClick(){
      this.$emit('go', {
        id: 'newProductInfo',
        name: '新建产品信息',
      })
    }
  },
  created(){
    this.getProductList()
  }
}
</script>

<style lang="scss" scoped>
.product{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    &__title{
      font-weight: bold;
      color: black;
      font-size: 18px;
    }
    &__search{
      display: flex;
    }
    &__item{
      display: flex;
      align-items: center;
      margin: 0 5px;
      ::v-deep .el-input__inner{
        border-radius: 0;
      }
    }
    &__input{
      width: 250px;
    }
    &-status{
      display: flex;
      padding: 5px 10px;
    }
    &-module{
      &__title{
        color: #00a0c7;
      }
      &__tip{
        color: black;
      }
    }
    &__btn{
      padding: 0 20px;
      margin-left: 10px;
      height: 30px;
      line-height: 30px;
      color: white;
      background: #00a0c7;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
